import { useEffect, useRef } from 'react';

const clamp = (value) => Math.min(Math.max(value, 0), 1);

// Writes scroll progress through an element to its --p custom property.
// "pinned" measures the sticky travel of a tall section; "through" measures it crossing the viewport.
export function useScrollProgress(ref, { mode = 'pinned', onChange } = {}) {
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    let frame = 0;
    const update = () => {
      frame = 0;
      const rect = el.getBoundingClientRect();
      const viewport = window.innerHeight;
      const progress = mode === 'pinned'
        ? clamp(-rect.top / Math.max(rect.height - viewport, 1))
        : clamp((viewport * 0.85 - rect.top) / (rect.height + viewport * 0.3));
      el.style.setProperty('--p', progress.toFixed(4));
      if (onChangeRef.current) onChangeRef.current(progress);
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
    };
  }, [ref, mode]);
}
